import { SharedModule } from '@app/shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { PaymentManagementRoutingModule } from '@app/payment-management/payment-management-routing.module';

import { NewPaymentComponent } from '@app/payment-management/new-payment/new-payment.component';
import { PaymentPeriodicFormComponent } from '@app/payment-management/payment-periodic-form/payment-periodic-form.component';
import { PaymentSingleFormComponent } from '@app/payment-management/payment-single-form/payment-single-form.component';
import { PaymentManagementDetailComponent } from '@app/payment-management/payment-management-detail/payment-management-detail.component';
import { PaymentFormComponent } from '@app/payment-management/payment-form/payment-form.component';
import { PaymentTaskDetailComponent } from './payment-task-detail/payment-task-detail.component';
import { PaymentPeriodrangeFormComponent } from '@app/payment-management/payment-periodrange-form/payment-periodrange-form.component';

import { AdminGuard } from '@app/core/guards/admin.guard';

import { AuthenticationGuard } from '@app/core';

@NgModule({
  imports: [
    CommonModule,
    PaymentManagementRoutingModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgSelectModule,
    SharedModule
  ],
  declarations: [
    PaymentManagementDetailComponent,
    NewPaymentComponent,
    PaymentFormComponent,
    PaymentPeriodicFormComponent,
    PaymentSingleFormComponent,
    PaymentPeriodrangeFormComponent,
    PaymentTaskDetailComponent
  ],
  providers: [ AdminGuard, AuthenticationGuard ]
})
export class PaymentManagementModule { }
